import IService from "@api/iService";
import {IInventoryItem, IInventoryLog} from "@interfaces/consumer/users";
import {PanelTableDataModel} from "@models/panel";
import {PanelTableData} from "@interfaces/panel";
import {PutInventoryItemModel} from "@models/consumer/items";

export default class ConsumerInventoryService extends IService {
    fetchInventory = async (userId: string) => {
        return await this.getApi<IInventoryItem[]>(`/api/consumer/inventory/${userId}/`);
    }

    fetchInventoryList = async (userId: string, model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IInventoryItem[]>>(`/api/consumer/inventory/${userId}/`, model);
    }

    fetchInventoryLogs = async (userId: string, model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<IInventoryLog[]>>(`/api/consumer/logs/item/${userId}/`, model);
    }

    addInventoryItem = async (model: PutInventoryItemModel) => {
        return await this.putApi<IInventoryItem>(`/api/consumer/inventory/`, model);
    }

    deleteInventoryItem = async (userId: string, itemId: string) => {
        return await this.deleteApi(`/api/consumer/inventory/${userId}/${itemId}/`);
    }
}